module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquarius/aqr_lines-1ea0ed865a726229d74cc2659e2477f3.gif";